import { Component } from '@angular/core';

@Component({
  selector: 'app-ai-intraction',
  templateUrl: './ai-intraction.component.html',
  styleUrl: './ai-intraction.component.scss'
})
export class AiIntractionComponent {

}
